module.exports = __webpack_public_path__ + "img/tip-bg.994ee2b0.png";